module.exports = "https://bin.bnbstatic.com/_next/static/images/BusinessDevelopment-6f252461fa87defd80b4afba86e1cc05.svg";